import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { routesFor, type Lang } from "./primitives";

/**
 * CTA inferior móvil: aparece tras salir el hero, se oculta con el menú abierto
 * o cuando hay un campo de formulario enfocado (teclado en pantalla).
 */
export const MobileCta = ({
  menuOpen,
  language = "es",
}: {
  menuOpen: boolean;
  language?: Lang;
}) => {
  const [visible, setVisible] = useState(false);
  const [typing, setTyping] = useState(false);
  const routes = routesFor(language);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.7);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const check = () => {
      const el = document.activeElement;
      const tag = el?.tagName.toLowerCase();
      setTyping(tag === "input" || tag === "textarea" || tag === "select");
    };
    document.addEventListener("focusin", check);
    document.addEventListener("focusout", check);
    return () => {
      document.removeEventListener("focusin", check);
      document.removeEventListener("focusout", check);
    };
  }, []);

  const hidden = !visible || menuOpen || typing;

  return (
    <div className="v3-mobile-cta lg:hidden" data-hidden={hidden ? "true" : undefined}>
      <Link to={routes.seoDiagnosis} className="v3-btn w-full" tabIndex={hidden ? -1 : 0}>
        {language === "es" ? "Solicitar diagnóstico SEO" : "Request SEO diagnosis"}
      </Link>
    </div>
  );
};
